export async function loadExternalPushInteraction(engine, refresh = true) {
    await engine.addInteractor("externalPush", async (container) => {
        const { Pusher } = await import("./Pusher.js");
        return new Pusher(container);
    }, refresh);
}
export * from "./Options/Classes/Push.js";
export * from "./Options/Interfaces/IPush.js";
